import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import ModuleLazyLoaderService from '../../services/module-lazy-loader'
import StringTableService from '../../services/string-table'
import RouteMapService from '../../services/route-map'
import StoreService from '../../services/ephemeral-store'
import UtilService from '../../services/util'
import Auth from '../../actions/auth'
import style from './style.scss'

import FullScreenForm from '../../components/full-screen-form'

export function getMarkup(showLogoutButton = false, text = '(Hold on tight!)') {

    return ModuleLazyLoaderService
        .load([
            'react-bootstrap',
            'react-router-bootstrap'
        ])
        .then((modules) => {

            const {
                Button,
                Modal
            } = modules['react-bootstrap']

            const { LinkContainer } = modules['react-router-bootstrap']

            return (
                <Modal show>
                    <Modal.Header>
                        <Modal.Title>Logging into the domain</Modal.Title>
                    </Modal.Header>
                    {text &&
                        <Modal.Body>
                            {text}
                        </Modal.Body>
                    }
                    {showLogoutButton &&
                        <Modal.Footer>
                            <LinkContainer to={RouteMapService.lookupMap.logout.route}>
                                <Button
                                    bsStyle="primary"
                                    className={style.logoutButton}
                                >
                                    Log out
                                </Button>
                            </LinkContainer>
                        </Modal.Footer>
                    }
                </Modal>
            )
        })
}

export function navigateToDeepLink(dispatch) {
    const deepLinkKey = StringTableService.getString(StringTableService.keys.deepLinkKey)
    const dashboardRoute = RouteMapService.lookupMap.dashboard.route
    const store = new StoreService()
    store.get(deepLinkKey)
        .then((deepLink) => {
            if (UtilService.skipDeepLinkingRoute(deepLink)) {
                deepLink = dashboardRoute
            }
            dispatch(push(deepLink || dashboardRoute))
        })
        .catch(() => {
            dispatch(push(dashboardRoute))
        })
}

class LoginGSMPage extends Component {

    static propTypes = {
        auth: PropTypes.object.isRequired,
        authenticated: PropTypes.bool.isRequired,
        dispatch: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)
        this.state = {
            markup: null
        }
    }

    componentDidMount() {
        if (this.props.authenticated) {
            navigateToDeepLink(this.props.dispatch)
            return
        }
        this.startAuthentication()
        getMarkup()
            .then((markup) => {
                this.setState({
                    markup
                })
            })
            .catch((error) => {
                UtilService.safeLog(error.stack)
            })
    }

    startAuthentication() {
        const { auth, dispatch } = this.props
        dispatch(auth.start())
    }

    render() {
        return <FullScreenForm>{this.state.markup}</FullScreenForm>
    }

}

const mapStateToProps = (state) => {
    const { auth } = state
    return {
        auth: new Auth(),
        authenticated: auth.authenticated
    }
}

export default connect(mapStateToProps)(LoginGSMPage)


// WEBPACK FOOTER //
// src/pages/login-gsm-page/index.js